module.exports = __webpack_public_path__ + "img/wait.377a8cc1.png";